var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Banner'),_c('About'),_c('Medical'),_c('Smart'),_c('Partners'),_c('News')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }